<template>
	<div class="full-image" v-if="show" :before-close="close" :modal="true">
		<div class="mask" @click="close"></div>
		<div class="image-box">
			<img :src="url" @click.stop />
		</div>
		<div class="close" @click="close"><i class="el-icon-close"></i></div>
	</div>
</template>

<script>
export default {
	name: "fullImage",
	data() {
		return {
			show: false,
			url: ''
		}
	},
	methods: {
		open(url) {
			this.show = true;
			this.url = url;
		},
		close() {
			this.show = false;
		}
	}
}
</script>

<style lang="scss">
.full-image {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 9999;

	.mask {
		position: fixed;
		width: 100%;
		height: 100%;
		background: black;
		opacity: 0.5;
	}

	.image-box {
		position: relative;
		width: 100%;
		height: 100%;
		pointer-events: none; /* 让点击穿透，但子元素 img 需要恢复点击 */

		img {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			max-height: 100%;
			max-width: 100%;
			pointer-events: auto; /* 恢复图片的点击事件，防止误触关闭 */
		}
	}

	.close {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 20px;
		right: 20px;
		cursor: pointer;
		background: #333;
		border-radius: 50%;
		padding: 10px;
		opacity: 0.5;

		i {
			font-weight: bold;
			font-size: 20px;
			color: white;
		}
	}
}
</style>